export default "__VITE_ASSET__f15929fc__"